import { anEntityInterface } from '__generated__';
import { delay, HttpResponse } from 'msw';

import { mockEntityMetadataQueryOperationQuery } from '@sbu/views.entitymetadata/build/mocks';

export const handlers = [
  mockEntityMetadataQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          entity: anEntityInterface(),
        },
      });
    }
  ),
];
